import { lazy, Suspense } from 'react';

import Main from './Main';

import { useWindowSize } from '@hooks/useWindowSize';
import type { MatchUnitServiceOptions } from '@services/MatchUnitService';
import useMatch from '@shared/MatchUnit/useMatch';

const PotmCard = lazy(() => import(/* webpackPrefetch: true */ '@shared/PotmCard'));

const App = ({
  options: {
    content,
    matchOptions,
    matchMetadata,
    showModule,
    showPotm,
    potmStatTypes,
    isFemaleCompetition,
    hasAudioDescPage,
  },
}: {
  options: {
    content?: 'LIVE' | 'NON-LIVE';
    matchOptions?: MatchUnitServiceOptions;
    matchMetadata?: {
      liveBlogId?: string;
    };
    showModule?: boolean;
    showPotm?: boolean;
    potmStatTypes?: Record<string, string[]>;
    isFemaleCompetition?: boolean;
    hasAudioDescPage?: boolean;
  };
}) => {
  const { isDesktop } = useWindowSize();
  const match = useMatch(matchOptions.match);

  return (
    <>
      {showModule && !!matchMetadata?.liveBlogId && (
        <Main match={match} blogId={matchMetadata.liveBlogId} content={content} hasAudioDescPage={hasAudioDescPage} />
      )}
      {showPotm && !isDesktop && match?.playerOfTheMatch && (
        <Suspense>
          <PotmCard match={match} statTypes={potmStatTypes} isFemaleCompetition={isFemaleCompetition} />
        </Suspense>
      )}
    </>
  );
};

export default App;
